import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  DEVELOP: {
    id: 'Develop.develop',
    defaultMessage: 'Develop',
    description: '[Type: Label][Vis.: low] - Develop link in main navigation',
  },
});

const Develop = () => {
  const url = createURL('https://developer.surveymonkey.com', {
    ut_source: 'header',
  });
  const title = t(COPY.DEVELOP);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.DEVELOP} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.DEVELOP} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default Develop;
export { Develop };
